import { createSlice } from '@reduxjs/toolkit';
import { RoleDetailStateType } from 'src/types/roleDetail';

const initialState: RoleDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const roleDetailSlice = createSlice({
    name: 'roleDetail',
    initialState,
    reducers: {
        getRoleDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getRoleDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getRoleDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createRoleDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createRoleDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createRoleDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateRoleDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateRoleDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateRoleDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearRoleDetail: () => initialState,
    },
});

export const {
    getRoleDetailFetch,
    getRoleDetailFetchSuccess,
    getRoleDetailFetchFailure,
    createRoleDetailFetch,
    createRoleDetailFetchSuccess,
    createRoleDetailFetchFailure,
    updateRoleDetailFetch,
    updateRoleDetailFetchSuccess,
    updateRoleDetailFetchFailure,
    clearRoleDetail,
} = roleDetailSlice.actions;

export default roleDetailSlice.reducer;
